<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="6">
        <div class="text-center">
          <img src="img/waf_level.png"
            class="text-center"
            style="margin-left: auto; margin-right: auto;width: auto; height:150px;"
          >
        </div>
      </b-col>
      <b-col sm="6">
        <p :style="`${server.level >= 4 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> 레벨 4는 정책 레벨 1~4 가 탐지 됩니다 </p>
        <p :style="`${server.level >= 3 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> 레벨 3는 정책 레벨 1~3 가 탐지 됩니다 </p>
        <p :style="`${server.level >= 2 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> 레벨 2는 정책 레벨 1~2 가 탐지 됩니다 </p>
        <p :style="`${server.level >= 1 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> 레벨 1는 정책 레벨 1 가 탐지 됩니다 </p>
        <hr>
        <p>
          레벨이 높을수록 공격이 더 넓은 범위의 공격이 탐지됩니다
        </p>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="2">기본 설정(1 권장) <br><small>숫자를 클릭하세요</small></b-col>
      <b-col sm="3" style="cursor: pointer;" @click="server.level = server.level < 4 ? server.level + 1 : 1">
        <strong style="cursor: pointer;">보안 정책 레벨</strong>
        <small style="cursor: pointer;">( Level : {{server.level}} )</small>
      </b-col>
      <b-col sm="3" style="cursor: pointer;">
        <b-form-radio-group @change="update($event, 'level')" style="cursor: pointer;" id="ph_level" v-model="server.level" :options="codes.WAF_LEVEL"></b-form-radio-group>
      </b-col>
      <b-col sm="3" class="text-center" style="cursor: pointer;">
        <strong @click="change">방화벽 정책 :
          <b-badge style="cursor: pointer;" v-if="server.mode == 0" variant="secondary">미사용</b-badge>
          <b-badge style="cursor: pointer;" v-if="server.mode == 1" variant="warning">탐지모드</b-badge>
          <b-badge style="cursor: pointer;" v-if="server.mode == 2" variant="danger">차단모드</b-badge>
        </strong>
        <!-- <b-form-radio-group id="ph_mode" v-model="server.mode" :options="codes.WAF_MODE"> </b-form-radio-group> -->
      </b-col>
      <b-col sm="2"></b-col>
      <!-- <b-col md="3">
        <div class="pull-right">
          <b-button size="sm" variant="success" @click="rule_confirm = true">Apply</b-button>
          <b-button size="sm" variant="warning" @click="apply_modal = true">Apply to other servers</b-button>
        </div>
      </b-col> -->
    </b-row>
    <hr>
    <b-row class="text-left">
      <b-col>
        <b-form-group>
          <h5>
            <b-badge variant="success">안내</b-badge>
            <small> <strong>
              즉시 보안 레벨을 높게 설정하면 서비스 문제가 발생할 수 있습니다. 방화벽 레벨 4를 장기 계획으로 설정하는 것이 좋습니다
            </strong></small>
            <hr>
            <small> <strong> * 미사용 : 현재 선택한 도메인에 대해 WEBCastle 기능 사용 안 함 </strong></small><br>
            <small> <strong> * <b-badge variant="warning">탐지 모드</b-badge> : 탐지만 하고 차단하지 않습니다 </strong></small><br>
            <small> <strong> * <b-badge variant="danger">차단 모드</b-badge> : 탐지 및 차단을 수행합니다 </strong></small>
          </h5>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
